import React from "react";
import queryString from 'query-string';
import ReactTooltip from 'react-tooltip';
import { Link } from "react-router-dom";
import { customizeSVG } from 'utils/customizeSVG.jsx';
import { ReactComponent as IconChevronLeft } from "assets/images/icons/project-icons/chevron-left.svg";
import { ReactComponent as IconChevronRight } from "assets/images/icons/project-icons/chevron-right.svg";

const Pagination = (props) => {

    customizeSVG();

    const qs = queryString.parse(props.url);
    delete qs['page'];
    // console.log("qs", qs);
    let qsToUrl = new URLSearchParams(qs).toString();
    qsToUrl = "?" + ((qsToUrl !== "")? qsToUrl + "&" : "");
    // console.log("qsToUrl", qsToUrl);

    const {data} = props;
    const startIndex = ((data.page-1) * data.limit) + 1;
    const lastIndex = ((data.page * data.limit) <= data.totalDocs)? (data.page * data.limit) : data.totalDocs;


    let hasPrevPage, prevPage;

    if (typeof data.hasPrevPage !== 'undefined'){
        hasPrevPage = data.hasPrevPage;
    }
    else if (typeof data.hasPreviousPage !== 'undefined'){
        hasPrevPage = data.hasPreviousPage;
    }

    if (typeof data.previousPage !== 'undefined'){
        prevPage = data.previousPage;
    }
    else if (typeof data.prevPage !== 'undefined'){
        prevPage = data.prevPage;
    }

    return (

        <>
            <ReactTooltip />

            <div className="py-4 px-4 text-sm flex">

                <div className="w-full hidden my-auto sm:w-1/2 sm:block">
                    Showing {startIndex} - {lastIndex} items out of {data.totalDocs} results found
                </div>

                <div className="w-full sm:w-1/2 my-auto">
                    <div className="flex justify-end">
                        <div className="mr-4 my-auto">
                            {data.page} of {data.totalPages}
                        </div>

                        <div className="pagination">
                            {(hasPrevPage) && 
                                <Link to={qsToUrl + "page=" + prevPage} data-tip={"Page " + prevPage} className="pagination-items group">
                                    <IconChevronRight className="customizeSVG pagination-items-icon" />
                                </Link>
                            }
                            {(!hasPrevPage) && 
                                <div className="pagination-items group disabled">
                                    <IconChevronRight className="customizeSVG pagination-items-icon disabled" />
                                </div>
                            }


                            {(data.hasNextPage) && 
                                <Link to={qsToUrl + "page=" + data.nextPage} data-tip={"Page " + data.nextPage} className="pagination-items group">
                                    <IconChevronLeft className="customizeSVG pagination-items-icon" />
                                </Link>
                            }
                            {(!data.hasNextPage) && 
                                <div className="pagination-items group disabled">
                                    <IconChevronLeft className="customizeSVG pagination-items-icon disabled" />
                                </div>
                            }
                        </div>

                    </div>
                </div>

            </div>
        </>
    );
};

export default Pagination;
